import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import addHeader from "./_header";
import addList from "./_list";

const { app } = window;

function addDataTable(vuw) {
	if( !( vuw instanceof Klass("Vuw") ) ) {
		throw new TypeError("arguments[0] must be Vuw instance.");
	}
	
	vuw.add("dataTable", {
		selector() {
			return $("<table/>").addClass("data-table tbl-datalist").attr("id", "data_table")
			.append( $("<thead/>"), $("<tbody/>") )
			.appendTo(this.container.$content);
		},
		
		refresh() {
			const { config } = app.module;
			
			this.$self.attr("data-style", config.listStyle || "classic");
			
			// 部品の中身を空にする
			this.get("header").$self.empty();
			const vuw = this.get("list");
			vuw.removeReplicants().$self.empty();
			delete vuw.$replicantTemplate;
			
			// テンプレートを生成する
			u_.isObject(config.dataParams) && this._createListTemplate(config.dataParams);
			
			// ページャーを隠す
			vuw.get("pager").$self.addClass("hide");
			
			return true;
		},
		
		/**
		 * initList用のテンプレートhtmlを生成
		 * @param {Object} dataParams
		 * @returns this
		 */
		_createListTemplate(dataParams) {
			const $header = $("<tr/>");
			const $artcl = $header.clone();
			
			// 「更新日」は必ず表示するようにするため、dataParamsを一時的に書き換え
			!dataParams.dateUpd && (dataParams.dateUpd = {
				name: "更新日時",
				inpType: "datetime",
				isListview: true,
				sort: true,
				isTemporary: true		// 後でdataParamsを戻す時用にパラメータを追加
			});
			
			const paramKeys = Object.keys(dataParams);
			const paramLen = paramKeys.length;
			const flgs = {
				keys: [],
				head: {},
				body: {}
			};
			
			for(let i = 0; i < paramLen; i++) {
				const pk = paramKeys[i];
				const pi = dataParams[pk];
				if(!pi.isListview) {
					continue;
				}
				
				const $th = $("<th/>").addClass(`col-${pk}`).attr({
					"data-type": pi.inpType
				}).append(
					$("<span/>").html( $.parseHTML(pi.name) )
				);
				
				if( (/<\//).test(pi.name) ) {
					// remove tags
					pi.name = $th.text();
				}
				
				const $td = $("<td/>").addClass(`col-${pk}`).attr({
					"data-type": pi.inpType,
					"data-pn": pi.name
				});
				
				// [header] ソート設定がなされていれば反映
				!!pi.sort && $("<span/>").append(
					$("<span/>").addClass("btn-sort asc hover-target").attr({
						title: `${pi.inpType === "period" ? "開始日を" : ""}昇順で並び替えます`
					}),
					$("<span/>").addClass("btn-sort desc hover-target").attr({
						title: `${pi.inpType === "period" ? "開始日を" : ""}降順で並び替えます`
					})
				).attr("id", `sort_${pk}`).addClass("area-sort")
				.appendTo( $th.addClass("is-sortable") );
				
				$("<var/>").attr("data-echo-pd", pk).appendTo($td);
				
				if(pi.inpType === "flg") {
					// flg項目は右側に表示するため、退避しておく
					flgs.keys.push(pk);
					flgs.head[pk] = $th;
					flgs.body[pk] = $td;
				} else {
					$th.appendTo($header);
					$td.appendTo($artcl);
				}
			}
			
			// 退避したflg項目を$artclに追加
			const flgKeysLength = flgs.keys.length;
			for(let i = 0; i < flgKeysLength; i++) {
				flgs.head[ flgs.keys[i] ].appendTo($header);
				flgs.body[ flgs.keys[i] ].appendTo($artcl);
			}
			
			// dataParamsにdateUpdが追加されていたら戻す
			!!dataParams.dateUpd.isTemporary && (delete dataParams.dateUpd);
			
			// [管理機能]
			const $btns = $("<span/>").addClass("area-btns").append(
				$("<a/>").addClass("btn-preview").append(
					$("<span/>").text("確認")
				),
				$("<a/>").addClass("btn-edit").append(
					$("<span/>").text("修正")
				),
				$("<a/>").addClass("btn-delete").append(
					$("<span/>").text("削除")
				)
			);
			
			$("<th/>").text("管理").addClass("col-func").appendTo($header);
			$("<td/>").addClass("col-func").attr({
				"data-pn": "管理"
			}).append($btns).appendTo($artcl);
			
			this.get("header").$self.append($header);
			this.get("list").setArticleTemplate($artcl);
			
			// コールバックの実行
			const dataKey = app.module.getDataKey();
			if( u_.isFunction(app.customizeListTemplate[dataKey]) ) {
				app.customizeListTemplate[dataKey].call(app, $artcl, app.module.config);
			}
			if( u_.isFunction(app.customizeListTemplate.always) ) {
				app.customizeListTemplate.always.call(app, $artcl, app.module.config);
			}
			
			return this;
		}
	}, function() {
		addHeader(this);
		addList(this);
	});
}

export default addDataTable;
